module.exports = __webpack_public_path__ + "static/img/ri-heart-line.e7e9c88b.svg";